import React, { createContext, useState, useContext } from "react";
// import { createChartTile } from "./utils"; // reuse your function

// Simple unique ID generator
function createChartTile(prefix = "chart") {
    return prefix + "_" + Math.random().toString(36).substr(2, 9);
}


const layouts = [

    {
        key: "1c", // 1 chart layout
        layout: createChartTile(), // single tile
    },
    {
        key: "2c-l1", // 2 chart layout 1
        layout: {
            direction: "row", // horizontal split
            first: createChartTile(),   // must match ELEMENTS key
            second: createChartTile(),
        },
    },
    {
        key: "2c-l2",  // 2 chart layout 2
        layout: {
            direction: "column", // vertical split
            first: createChartTile(),
            second: createChartTile(),
        },
    },
    {
        key: "3c-l1",  // 3 chart layout 1
        layout: {
            direction: "column", // vertical split
            first: createChartTile(),
            second: {
                direction: "row",
                first: createChartTile(),
                second: createChartTile(),
            },
        },
    },
    {
        key: "3c-l2",  // 3 chart layout 1
        layout: {
            direction: "column", // vertical split
            first: {
                direction: "row",
                first: createChartTile(),
                second: createChartTile(),
            },
            second: createChartTile(),

        },
    },

    {
        key: "3c-l3",  // 3 chart layout 1
        layout: {
            direction: "row", // vertical split
            first: createChartTile(),
            second: {
                direction: "column",
                first: createChartTile(),
                second: createChartTile(),
            },
        },
    },
    {
        key: "3c-l4",  // 3 chart layout 1
        layout: {
            direction: "row", // vertical split
            first: {
                direction: "column",
                first: createChartTile(),
                second: createChartTile(),
            },
            second: createChartTile(),

        },
    },
    {
        key: "3c-l5",
        layout: {
            direction: "row", // horizontal split (side by side)
            first: createChartTile(), // first column
            weight: 20,
            second: {
                direction: "row", // second split for second & third column
                first: createChartTile(), // second column
                second: createChartTile(), // third column
            },
        },
    },
    {
        key: "4c-l1",
        layout: {
            direction: "column", // horizontal split (side by side)
            first: {
                direction: "row", // second split for second & third column
                first: createChartTile(), // second column
                second: createChartTile(), // third column
            },
            second: {
                direction: "row", // second split for second & third column
                first: createChartTile(), // second column
                second: createChartTile(), // third column
            },
        },
    },
    {
        key: "4c-l2",
        layout: {
            direction: "column", // vertical split
            first: {
                direction: "row", // top row split
                first: createChartTile(),
                second: {
                    direction: "row", // split again for 2nd & 3rd
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
            second: createChartTile(), // bottom single chart
        },
    },
    {
        key: "4c-l3",
        layout: {
            direction: "column", // vertical split
            first: createChartTile(), // bottom single chart

            second: {
                direction: "row", // top row split
                first: createChartTile(),
                second: {
                    direction: "row", // split again for 2nd & 3rd
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
        },
    },
    {
        key: "4c-l4",
        layout: {
            direction: "row", // main split left vs right
            first: createChartTile(), // left column, 1 chart
            second: {
                direction: "column", // right side split into 3
                first: createChartTile(),
                second: {
                    direction: "column", // nest again for 2nd & 3rd chart
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
        },
    },
    {
        key: "4c-l5",
        layout: {
            direction: "row", // main split left vs right
            first: {
                direction: "column", // right side split into 3
                first: createChartTile(),
                second: {
                    direction: "column", // nest again for 2nd & 3rd chart
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
            second: createChartTile(), // left column, 1 chart

        },
    },
    {
        key: "mc-l1",
        layout: {
            direction: "column", // vertical split
            first: createChartTile(), // top single chart
            second: {
                direction: "row", // bottom row with 4 charts
                first: createChartTile(),
                second: {
                    direction: "row",
                    first: createChartTile(),
                    second: {
                        direction: "row",
                        first: createChartTile(),
                        second: createChartTile(),
                    },
                },
            },
        },
    },
    {
        key: "mc-l2",
        layout: {
            direction: "row", // main split left vs right
            first: {
                direction: "column", // right side split into 3
                first: createChartTile(),
                second: {
                    direction: "column", // nest again for 2nd & 3rd chart
                    first: createChartTile(),
                    second: {
                        direction: "column", // nest again for 2nd & 3rd chart
                        first: createChartTile(),
                        second: createChartTile(),
                    },
                },
            },
            second: createChartTile(), // left column, 1 chart

        },
    },
    {
        key: "mc-l3",
        layout: {
            direction: "row", // main split left vs right
            first: createChartTile(), // left column, 1 chart

            second: {
                direction: "column", // right side split into 3
                first: createChartTile(),
                second: {
                    direction: "column", // nest again for 2nd & 3rd chart
                    first: createChartTile(),
                    second: {
                        direction: "column", // nest again for 2nd & 3rd chart
                        first: createChartTile(),
                        second: createChartTile(),
                    },
                },
            },

        },
    },
    {
        key: "mc-l4",
        layout: {
            direction: "column", // 2 rows
            first: {
                direction: "row", // first row
                first: createChartTile(), // left big chart
                second: {
                    direction: "column", // right side stacked
                    first: createChartTile(), // top right
                    second: createChartTile(), // bottom right
                },
            },
            second: {
                direction: "row", // second row 3 charts in a row
                first: createChartTile(),
                second: {
                    direction: "row",
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
        },
    },
    {
        key: "mc-l5",
        layout: {
            direction: "column", // 2 rows
            first: {
                direction: "row", // top row
                first: createChartTile(),
                second: {
                    direction: "row",
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
            second: {
                direction: "row", // bottom row
                first: createChartTile(),
                second: {
                    direction: "row",
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
        },
    },

    {
        key: "mc-l6",
        layout: {
            direction: "column", // 2 rows

            first: {
                direction: "row", // second row
                first: createChartTile(), // left full chart
                second: {
                    direction: "column", // right side stacked
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
            second: {
                direction: "row", // first row
                first: createChartTile(), // left full chart
                second: {
                    direction: "column", // right side stacked
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
        },
    },
    {
        key: "mc-l7",
        layout: {
            direction: "column", // 2 rows
            first: {
                direction: "row", // first row
                first: {
                    direction: "column", // right side stacked
                    first: createChartTile(),
                    second: createChartTile(),
                },
                second: createChartTile(), // left full chart

            },
            second: {
                direction: "row", // first row
                first: {
                    direction: "column", // right side stacked
                    first: createChartTile(),
                    second: createChartTile(),
                },
                second: createChartTile(), // left full chart

            },
        },
    },
    {
        key: "mc-l8",
        layout: {
            direction: "column", // vertical split
            first: {
                direction: "row", // top row split
                first: createChartTile(),
                second: createChartTile(),

            },

            second: {
                direction: "row", // top row split
                first: createChartTile(),
                second: {
                    direction: "row", // split again for 2nd & 3rd
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
        },
    },
    {
        key: "mc-l9",
        layout: {
            direction: "column", // vertical split

            first: {
                direction: "row", // top row split
                first: createChartTile(),
                second: {
                    direction: "row", // split again for 2nd & 3rd
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
            second: {
                direction: "row", // top row split
                first: createChartTile(),
                second: createChartTile(),

            },

        },
    },
    {
        key: "mc-l10",
        layout: {
            direction: "column", // 3 rows
            first: {
                direction: "row", // row 1
                first: createChartTile(),
                second: {
                    direction: "row",
                    first: createChartTile(),
                    second: createChartTile(),
                },
            },
            second: {
                direction: "column", // rows 2 & 3
                first: {
                    direction: "row", // row 2
                    first: createChartTile(),
                    second: {
                        direction: "row",
                        first: createChartTile(),
                        second: createChartTile(),
                    },
                },
                second: {
                    direction: "row", // row 3
                    first: createChartTile(),
                    second: {
                        direction: "row",
                        first: createChartTile(),
                        second: createChartTile(),
                    },
                },
            },
        },
    }


];

const LayoutContext = createContext();

export const LayoutProvider = ({ children }) => {
    const [currentLayout, setCurrentLayout] = useState(layouts[0].layout);
    const [activeLay, setActiveLay] = useState("1c")

    console.log(activeLay, "act");


    const switchLayout = (key) => {
        const selected = layouts.find((l) => l.key === key);
        setActiveLay(selected.key);
        if (selected) setCurrentLayout(selected.layout);
    };

    return (
        <LayoutContext.Provider value={{ currentLayout, switchLayout, setCurrentLayout, activeLay }}>
            {children}
        </LayoutContext.Provider>
    );
};

export const useLayout = () => useContext(LayoutContext);
